import { DeleteOutlined, DownOutlined, PlusOutlined, ReloadOutlined } from "@ant-design/icons"
import { Button, Dropdown, Tooltip } from "antd"
import type { MenuProps } from "antd"
import type React from "react"
import { memo } from "react"

interface AdminTableActionsProps {
  onAdd: () => void
  onRefresh: () => void
  onBatchDelete?: () => void
  selectedRowKeys?: React.Key[]
  loading?: boolean
}

/**
 * Component các nút thao tác trên bảng Quản trị viên
 */
const AdminTableActions: React.FC<AdminTableActionsProps> = memo(
  ({ onAdd, onRefresh, onBatchDelete, selectedRowKeys = [], loading = false }) => {
    const hasSelection = selectedRowKeys.length > 0

    const handleMenuClick: MenuProps["onClick"] = (e) => {
      if (e.key === "delete" && onBatchDelete) {
        onBatchDelete()
      }
    }

    const menuItems: MenuProps["items"] = [
      {
        key: "delete",
        label: "Xóa hàng loạt",
        icon: <DeleteOutlined />,
        danger: true,
      },
    ]

    return (
      <div className="flex grow items-center justify-end gap-2">
        {hasSelection && (
          <Dropdown menu={{ items: menuItems, onClick: handleMenuClick }} trigger={["click"]}>
            <Button size="small" icon={<DownOutlined />}>
              Thao tác
            </Button>
          </Dropdown>
        )}

        <Tooltip title="Thêm tài khoản admin mới">
          <Button type="primary" size="small" icon={<PlusOutlined />} onClick={onAdd}>
            Thêm mới
          </Button>
        </Tooltip>

        <Tooltip title="Tải lại dữ liệu">
          <Button type="default" size="small" icon={<ReloadOutlined />} onClick={onRefresh} loading={loading} />
        </Tooltip>
      </div>
    )
  }
)

AdminTableActions.displayName = "AdminTableActions"

export default AdminTableActions
